import { createPlaybookMentionMarkdown } from 'src/components/ai/chat/ChatPanel/ChatEditor/ChatEditorMention/document-mention-markdown';

export function createRunPlaybookPrompt({
  playbookId,
  playbookTitle,
}: {
  playbookId: string;
  playbookTitle: string;
}): string {
  const mention = createPlaybookMentionMarkdown({
    displayText: playbookTitle,
    playbookId,
  });
  return `Run this playbook ${mention} against **[attach documents and provide additional instructions here]**`;
}
